import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { CRUDHnadler } from '../../domain/repositories/general/crud.handler';
import { Socio } from '../../domain/models/socio.model';
import { SocioManager } from '../../application/managers/socio.manager';
import { CreateSocioUseCase } from '@application/use-case/socio/createSocio.useCase';
import { UpdateSocioUseCase } from '@application/use-case/socio/updateSocio.useCase';
import { RetrieveSocioUseCase } from '@application/use-case/socio/retrieveSocio.useCase';
import { DeleteSocioUseCase } from '@application/use-case/socio/deleteSocio.useCase';
import { SocioAdapter } from '@infrastructure/adapter/socio.adapter';

/**
 *Servicio que expondrá al cliente las operaciones a realizar  y el enlace de la operación correspondiente al adaptador
 *
 * @export
 * @class SocioRepositoryService
 */
@Injectable({
  providedIn: 'root',
})
export class SocioRepositoryService {
  private socioService: any = null;
  constructor(http: HttpClient) {
    /**
     * Esta variable enlaza con el adaptador correspondiente que realiza la recuperación de los datos, 
     * en el futuro si se desea actualizar la forma de recuperación de estos datos, solo se realizara el cambio directamente al adaptador que realizar dichas conexión
     * @name sociioAdapter 
     * @type {SocioAdapter} */
    const socioAdapter: SocioAdapter = new SocioAdapter(http);
    const createE: CreateSocioUseCase = new CreateSocioUseCase(socioAdapter);
    const updateE: UpdateSocioUseCase = new UpdateSocioUseCase(socioAdapter);
    const deleteE: DeleteSocioUseCase = new DeleteSocioUseCase(socioAdapter);
    const retrieveE: RetrieveSocioUseCase = new RetrieveSocioUseCase(
      socioAdapter
    );
    this.socioService = new SocioManager(createE, updateE, deleteE, retrieveE);
  }

  save(employee: Socio): Observable<Socio> {
    return this.socioService.create(employee);
  }
  findById(id: number): Observable<Socio> {
    return this.socioService.get(id);
  }
  findAll(): Observable<Socio[]> {
    return this.socioService.getAll();
  }
  update(id: number, employee: Socio): Observable<Socio> {
    return this.socioService.update(id, employee);
  }
  deleteById(id: number): Observable<boolean> {
    return this.socioService.delete(id);
  }
}
